import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import 'react-datepicker/dist/react-datepicker.css'
import { Button, Modal } from 'react-bootstrap'
import { heightPercentageToDP } from '../../Utils/ResponsiveScreen'

const styles = {
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',
	},
}

export default class JobGeneralOptions extends Component {

	constructor(props) {
		super(props)
		this.state = {

			targetAreasList: this.props.data.targetAreasList ? this.props.data.targetAreasList : []
		}
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevProps.data.targetAreasList != this.props.data.targetAreasList) {
			this.setState({ targetAreasList: this.props.data.targetAreasList })
		}
	}

	changeTargetAreas = async (targetArea) => {
		const targetAreas = this.state.targetAreasList
		const { selectedTargetAreas } = this.props.data



		let finalTargetAreas = targetArea.parentArea ? selectedTargetAreas : []
		const targetAreaIndex = selectedTargetAreas.findIndex((area) => area.heading == targetArea.heading)
		if (targetAreaIndex != -1) {

			finalTargetAreas = selectedTargetAreas.filter((area) => area.heading != targetArea.heading)
		} else {
			finalTargetAreas.push(targetArea)

		}
		this.props.handleTargetAreas(finalTargetAreas)
	}

	sendPnValidation = () => {
		const { sendPushNotification, sendPNWithImage, pnTitle, bigTextTitle } = this.props.data
		const pnTextValidation = sendPNWithImage ? pnTitle != '' : bigTextTitle != ''
		const sendPnValidation = sendPushNotification ? pnTextValidation : true
		return !sendPnValidation
	}
	render() {
		const { data } = this.props
		return (
			<div>
				<details>
					<summary>General Options</summary>
					<div class='content'>
						<div class='content'>
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleSendNotification}
									checked={data.sendPushNotification}
									id='sendPushNotification'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='sendPushNotification'>
									Send Push Notification
								</label>
							</div>

							{data.sendPushNotification ? (
								<div>
									<div style={{ marginRight: 10 }}>
										<input
											value={'regularTopic'}
											type='radio'
											checked={data.selectedPnPriority == 'regularTopic'}
											onChange={() => {
												this.props.handlePnPriority('regularTopic')
											}}
										></input>
										<text for={'regularTopic'}>{'Regular Topic'}</text>
									</div>

									<div style={{ marginRight: 10 }}>
										<input
											value={'topStories'}
											type='radio'
											checked={data.selectedPnPriority == 'topStories'}
											onChange={() => {
												this.props.handlePnPriority('topStories')
											}}
										></input>
										<text for={'topStories'}>{'Top Stories'}</text>
									</div>
									<div clss='row'>
										<Grid component='label' container alignItems='center' spacing={1}>
											<Grid item>With Big Text</Grid>

											<Grid item>
												<Switch
													checked={data.sendPNWithImage}
													onChange={() => this.props.handleChangeSendPNWith()}
													value='checkedA'
												/>
											</Grid>
											<Grid item>With Image</Grid>
										</Grid>
									</div>
									<text for='text'>PN Title : </text>
									<div>
										<input
											maxLength={65}
											type='text'
											onChange={(value) => {
												this.props.handlePNTitle(value)
											}}
											value={data.pnTitle ? data.pnTitle.substring(0, 65) : ''}
											placeholder='Please Enter PN Title'
										></input>
									</div>
									{!data.sendPNWithImage ? (
										<div>
											<text for='text'>Big Text : </text>
											<div>
												<textarea
													type='text'
													onChange={(value) => {
														this.props.handlebigTextTitle(value)
													}}
													value={data.bigTextTitle ? data.bigTextTitle : ""}
													placeholder='Please Enter Big Text'
												></textarea>
											</div>
										</div>
									) : (
										<div>
											<text for='text'> PN Description : </text>
											<div>
												<textarea
													maxLength={240}
													type='text'
													onChange={(value) => {
														this.props.handlePNDescription(value)
													}}
													value={data.pnDescription ? data.pnDescription.substring(0, 240) : ''}
													placeholder='Please Enter PN Description'
												></textarea>
											</div>
										</div>
									)}
								</div>
							) : null}
							{this.sendPnValidation() ? (
								<text style={styles.mandatoryErrorText}>{'Please fill pn all fields'}</text>
							) : null}

							<div class='row mb-2'>
								<label for='text'>Published Start Date </label>

								<div style={{ zIndex: 9999 }}>
									<DatePicker
										dateFormat={'dd/MM/yyyy HH:mm '}
										minDate={new Date()}
										selected={data.scheduledDate}
										showTimeSelect
										disabled={
											this.props.contentStatus != undefined &&
												this.props.contentStatus != null &&
												this.props.contentStatus == 'm#published'
												? true
												: false
										}
										onChange={(date) => this.props.setStartDate(date)}
									/>
								</div>
							</div>
							<div class='row mb-2' >
								<label for='text'>Published End Date </label>

								<div style={{ zIndex: 9999 }}>
									<DatePicker
										dateFormat={'dd/MM/yyyy HH:mm '}
										minDate={new Date()}
										selected={data.publishedEndDate}
										showTimeSelect
										onChange={(date) => this.props.setEndDate(date)}

									/>
								</div>
							</div>

							<div class='mb-2'>
								<div class='row'>
									<label for='text'>Target Area</label>
								</div>
								<div class='row'>

									{this.state.targetAreasList.map((item, index) => {
										const areaIndex = data.selectedTargetAreas.findIndex((area) => area.heading == item.heading)
										const isAreaSelected = areaIndex != -1 ? true : false
										return (

											< div key={index} style={item.parentArea ? { marginLeft: 15 } : {}} >
												<input
													value={item}
													type='checkbox'
													checked={isAreaSelected}
													onChange={() => {
														this.changeTargetAreas(item)
													}}
												></input>
												<text for={item.heading}>{item.heading}</text>
											</div>
										)
									})}
								</div>
							</div>


							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleAllowShare}
									checked={data.allowShare}
									id='allowshare'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='allowshare'>
									Allow Share
								</label>
							</div>

							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleAllowComments}
									checked={data.allowComments}
									id='allowComments'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='allowComments'>
									Allow Comments
								</label>
							</div>
							{/* <div className='custom-control custom-switch'>
                                <input
                                    type='checkbox'
                                    className='custom-control-input'
                                    onChange={this.props.handleCreateInBoxOffice}
                                    checked={data.createInBoxOffice}
                                    disabled={data.stickyPost || data.isInAppMessage}
                                    id='createInBoxOffice'
                                    readOnly
                                />
                                <label className='custom-control-label' htmlFor='createInBoxOffice'>
                                    Create In BoxOffice
                                </label>
                            </div> */}
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={this.props.handleChangeStickyPost}
									checked={data.stickyPost}
									id='stickyPost'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='stickyPost'>
									StickyPost
								</label>
							</div>
							{data.stickyPost ? (
								<div>
									<div class='row mb-2'>
										<label for='text'>Sticky End Date And Time</label>
										<DatePicker
											dateFormat={'dd/MM/yyyy HH:mm '}
											minDate={new Date()}
											selected={data.stickyEndDateTime}
											showTimeSelect
											onChange={(date) => this.props.handleChangeStickyEndDateTime(date)}
										/>
									</div>
									<div class='row mb-2'>
										<label for='text'>Position From Top </label>
										<input
											id='positionFromTop'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											onChange={(e) => {
												this.props.handleChangeStickyPositionFromTop(e.target.value)
											}}
											value={data.positionFromTop}
											placeholder='Please Enter Position'
										></input>
										{this.props.hasPositionFromTopError() ? (
											<text for='text' style={{ color: 'red', fontSize: 10 }}>
												Position From Top Cannot Be Empty
											</text>
										) : null}
									</div>
									<div class='mb-2'>
										<div class='row'>
											<label for='text'>Show Sticky</label>
										</div>
										<div class='row'>

											<div>
												<input
													value={'Unlimited'}
													type='radio'
													checked={data.showSticky == 'Unlimited'}
													onChange={() => {
														this.props.handleChangeShowStickyOption('Unlimited')
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
												></input>
												<text for='Unlimited'>Unlimited</text>
											</div>
											<div>
												<input
													value={'stickyTargetImpressions'}
													type='radio'
													checked={data.showSticky == 'stickyNoOfTimes'}
													onChange={() => {
														this.props.handleChangeShowStickyOption('stickyNoOfTimes')
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
												></input>
												<text for='stickyNoOfTimes'>Number Of Times</text>
											</div>
										</div>
									</div>
									<div>
										{data.showSticky == 'stickyNoOfTimes' ? (
											<div class='row mb-2'>
												<label for='text'>Number Of Times </label>
												<input
													id='stickyTargetImpressions'
													type='text'
													onKeyPress={(event) => {
														if (!/[0-9]/.test(event.key)) {
															event.preventDefault()
														}
													}}
													disabled={
														this.props.contentStatus != undefined &&
															this.props.contentStatus != null &&
															this.props.contentStatus == 'm#published' &&
															this.props.isPreviouslyStickyPost != undefined &&
															this.props.isPreviouslyStickyPost != null &&
															this.props.isPreviouslyStickyPost
															? true
															: false
													}
													onChange={(e) => {
														this.props.handleChangeStickyNoOfTimes(e.target.value)
													}}
													value={data.stickyTargetImpressions}
													placeholder='Please Enter Number Of Times'
												></input>
												{this.props.hasStickyNumberOfTimesError() ? (
													<text for='text' style={{ color: 'red', fontSize: 10 }}>
														Sticky Number Of Times Cannot Be Empty
													</text>
												) : null}
											</div>
										) : null}
									</div>
									<div>
										<label for='text'>Push this sticky post for</label>
										<input
											id='pushRankUpTo'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											style={{ width: '50px' }}
											disabled={
												this.props.contentStatus != undefined &&
													this.props.contentStatus != null &&
													this.props.contentStatus == 'm#published' &&
													this.props.isPreviouslyStickyPost != undefined &&
													this.props.isPreviouslyStickyPost != null &&
													this.props.isPreviouslyStickyPost
													? true
													: false
											}
											onChange={(e) => {
												this.props.handleChangePushRankUpTo(e.target.value)
											}}
											value={data.pushRankUpTo}
											placeholder='Please Enter Push Rank UpTo'
										></input>
										<label for='text'>Minutes To this Rank</label>
										<input
											style={{ width: '30px' }}
											id='pushRankTo'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											disabled={
												this.props.contentStatus != undefined &&
													this.props.contentStatus != null &&
													this.props.contentStatus == 'm#published' &&
													this.props.isPreviouslyStickyPost != undefined &&
													this.props.isPreviouslyStickyPost != null &&
													this.props.isPreviouslyStickyPost
													? true
													: false
											}
											onChange={(e) => {
												this.props.handleChangePushRankTo(e.target.value)
											}}
											value={data.pushRankTo}
											placeholder='Please Enter Push Rank To'
										></input>
										<div>
											{this.props.hasPushRankToError() ? (
												<text for='text' style={{ color: 'red', fontSize: 10 }}>
													Push Rank To Cannot Be Empty
												</text>
											) : null}
										</div>
										{this.props.hasPushRankUpToError() ? (
											<text for='text' style={{ color: 'red', fontSize: 10 }}>
												Push Rank UpTo Cannot Be Empty
											</text>
										) : null}
									</div>
								</div>
							) : null}

						</div>
					</div>
				</details >
			</div >
		)
	}
}